import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';

const LoginForm = ({ authenticateUser }) => {
  const [username, setUsername] = useState('admin');
  const [password, setPassword] = useState('72565123');
  const [rememberPassword, setRememberPassword] = useState(false);
  const [isLoggedIn, setLoggedIn] = useState(false);
  const [error, setError] = useState('');


  const handleLogin = () => {
    // Basic validation to check if username and password are filled in
    if (!username || !password) {
      setError('Please enter both username and password');
      return;
    }

    // Check if the entered credentials match any user
    const isAuthenticated = authenticateUser(username, password);

    if (isAuthenticated) {
      setLoggedIn(true);
    } else {
      setError('Invalid username or password');
    }
  };

  const handleRememberPassword = () => {
    setRememberPassword(!rememberPassword);
  };

  if (isLoggedIn) {
    return <Navigate to="/home" />;
  }

  return (
    <>
    <div className='bg-theme-primary-2 py-2 flex-center vh-100 vw-100'>
    <div className='container-xl bg-white border border-theme-primary-4 row shadow '>
          <div className="flex-center align-middle p-3 py-xl-5 col-md-6 col-lg-8 ">
              <div> <span className='font-primary fs-2 pg-2 pb-lg-5 text-center d-block text-theme-primary-15'>Double Diamond Design Process</span>
              <img src='/img/splash-big.png' className='img-fluid' alt="Splash" />  
              </div>
              
          </div>
          <div className='col-md-6 col-lg-4 flex-center bg-theme-primary-3'>
          <div id="login-form" className=' '>
              <h4 className='font-primary mb-2 mb-lg-3 text-center text-theme-primary-17'>Client Login</h4>              
              <label>
                Email ID/Username:
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}                  
                  className={`w-100 ${error && !username ? 'invalid' : ''}`}
                />
              </label>
              <br />
              <label>
                Password:
                <input 
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className={`w-100 ${error && !password ? 'invalid' : ''}`}
                />
              </label>
              
              <label className='text-black-5 d-none'>
                <input type="checkbox" className='me-1' checked={rememberPassword} onChange={handleRememberPassword} />Remember Password</label>
              <br />

              <div className='flex-center justify-content-between '>
              <button onClick={handleLogin}>Login</button>              
              <p className='mt-2'><a href="mailto:admin@ayatacommerce.com">Request Password?</a></p>
              </div>
              <div className=''>{error && <p className="bg-theme-pink text-white p-2 error-message fw-bold">{error}</p>}</div>
        </div>
        </div>
    </div>
    </div>
    
    </>
    
  );
};

export default LoginForm;